import './Works.css';
import { useState } from 'react';
import WorksContent from './WorksContent';
import SideMenu from '../SideMenu';
import SethL from '../../images/SethLI2P.jpg';
import DummyResume from '../../images/Portfolio2_DummyResume.pdf';
import VoicemailIcon from '../../images/Portfolio2VoicemailIcon.png';
import MailIcon from '../../images/Portfolio2MailIcon.png';
import ProfileIcon from '../../images/Portfolio2ProfileIcon.png';
import LocationIcon from '../../images/Portfolio2LocationIcon.png';

function Works() {

  return (
    <div className = 'works'>
      <SideMenu />
      <div className = 'works-content'>
        <WorksContent />
      </div>   
    </div>
  );
}

export default Works;